"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateTalentPoolRequestSchema = exports.CreateTalentPoolRequestSchema = exports.TalentPoolMembers = exports.TalentPoolQuerySchema = exports.TalentPoolCandidatePathParamsSchema = exports.TalentPoolIdPathParamsSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
exports.TalentPoolIdPathParamsSchema = zod_1.z.object({ poolId: schemas_1.UUIDSchema });
exports.TalentPoolCandidatePathParamsSchema = zod_1.z.object({
    candidateId: schemas_1.UUIDSchema,
    poolId: schemas_1.UUIDSchema,
});
exports.TalentPoolQuerySchema = schemas_1.PaginationQuerySchema.extend({ keyword: zod_1.z.string().optional() });
exports.TalentPoolMembers = schemas_1.PaginationQuerySchema.extend({ keyword: zod_1.z.string().optional() });
exports.CreateTalentPoolRequestSchema = zod_1.z.object({ name: zod_1.z.string().min(1).max(100) });
exports.UpdateTalentPoolRequestSchema = zod_1.z.object({ name: zod_1.z.string().min(1).max(100) });
